export default __webpack_public_path__ + "c62d9f876e9efa526a248563488898a2.png";